import { AdditionalInvestmentInputData } from '../models';

export const DEFAULT_ADDITIONAL_INVESTMENT: AdditionalInvestmentInputData = {
    label: 'System.AdditionalInvestment',
    value: ''
};
